<template>
  <div class="col-12">
    <Search
      :allowFields="$lang.reportLang.report_export_download_fields"
      :allowCollapse="false"
      :url="url"
      :title="$lang.reportLang.report_export_download_list"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :visibleAdd="false"
      :allowEdit="false"
      :dynamicButtons="availableButtons"
      :filterCatch="true"
      :dataNotExist="$lang.notRecordExist"
      operationField="دانلود فایل"
      ref="reportExportDownloadSearch"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";

export default {
  name: "exportMainSearch",
  components: {
    Search,
  },
  data() {
    return {
      url: this.$config.api_url + this.$config.report.export_main,
      availableButtons: [
        {
          id: "0",
          name: "exportMainDownload",
          iconFont: "fas fa-download fa-lg text-success",
          text: this.$lang.reportLang.download_file,
          click: this.downloadFile,
        },
      ],
    };
  },
  methods: {
    async downloadFile(item) {
      const { file_code: fileCode } = item;
      if (!fileCode) return;
      try {
        const url =
          this.$config.api_url +
          this.$config.report.attachment_download.replace("{0}", fileCode);
        window.open(url, "_blank");
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>
